/* eslint-disable prefer-destructuring */
const theme = {
  borders: {},
  borderWidths: [],
  borderStyles: [],
  radii: [],
  breakpoints: ['374px', '768px', '1024px', '1279px'],
  media: {
    grid: '1200px',
    'grid-gutter': ['10px', '20px', '40px', '60px', '80px', '120px'],
  },
  colors: {
    'dark-mode': '#2B2C32', // Currently not avaiable sitewide
    'pc-red': '#E1251B', // Primary colour for text, backgrounds, iconography, interactions
    'secondary-red': '#FF3300', // Secondary colour only for text on velvet background
    'tertiary-red': '#C2211C', // Tertiary colour only for hover/pressed states when control is red
    teal: '#007A85', // For CTAs, links and hover/pressed states when the control is dark grey
    'secondary-teal': '#00646d', // Secondary colour only for hover/pressed states when control is teal
    velvet: '#3D1952', // For backgrounds only, but it could replace the teal/red colour in controls later
    'secondary-velvet': '#80348E', // velvet section for pcma
    'secondary-action-velvet': '#EFDFF2', // text pills for special offers banner
    'tertiary-velvet': '#552877', // Currently not in use
    white: '#FFFFFF', // For text and background colouring
    black: '#000000', // Currently not in use
    'main-text': '#2B2C32', // For all text colour and footer/tooltip background
    'secondary-text': '#686868', // For form control borders, small copy, disabled state text and disclaimer text
    'light-grey': '#F6F6F7', // Primary background colour
    'cta-border-grey': '#CCCCCC', // CTA border grey for product blocks
    stone: '#EBEDEB', // Darker backgrounds to split sections
    'border-grey': '#D8D8D8', // Borders (dividers)
    'light-border-grey': '#E8E9EB', // Light borders/disabled button
    'insiders-yellow': '#FFF200', // Insiders branded yellow
    yellow: '#FBB600', // Pro tip component background
    pink: '#F9BBB4', // Optimum pink use for gallery ticker and optimum campaign banner
    'chart-pink': '#faecec', // Optimum background on new product chart
    purple: '#D6CEDB', // PC Money background on new product chart (chart currently not in use)
    brown: '#191105', // PCMC background colour used on No Frills campaign
    'holiday-red': '#e9c7b8', // 2021 Holiday insiders red used on animated fanned multi product card
    'holiday-green': '#bcd8e5', // 2021 Holiday insiders green used on animated fanned multi product card
    'pc-lilac': '#EFDFF2', // Currently not in use
    'esso-red': '#B82118', // ESSO Campaign for offer-details colour
    'surface-black': '#333333', // On surface primary secondary lm dark text
    'pc-pink': '#FBF7FC', // spotlight banner block pink
    'pc-dark-pink': '#FDEEED', // app rating background
    'joe-fresh-orange': '#EB6623', // joe fresh orange
    'joe-fresh-velvet': '#3B1A51', // joe fresh velvet
    'bullet-grey': '#ABAEB4', // bullet grey for carousel pagination
    'grey-text': '#666666', // primary and secondary light text
  },
  fonts: {
    averta: 'Averta, Arial, Helvetica, sans-serif',
    noir: 'Noir Pro, Arial, Helvetica, sans-serif',
  },
  fontSizes: [],
  fontWeights: {
    normal: 400,
    medium: 600,
    semiBold: 700,
    bold: 800,
  },
  lineHeights: [],
  letterSpacings: [],
  textDecoration: {},
  space: ['10px', '20px', '30px'],
  sizes: [],
  shadows: {
    small: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)',
  },
  transitions: [],
  zIndices: [0, 1, 2, 3, 6, 12, 24, 48, 96],
};

theme.breakpoints.sm = theme.breakpoints[0];
theme.breakpoints.md = theme.breakpoints[1];
theme.breakpoints.lg = theme.breakpoints[2];
theme.breakpoints.xlg = theme.breakpoints[3];

export default theme;
